import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { PRODUCTS } from '../data/content';
import ProductCard from './ProductCard';
import './Products.css';

export default function Products() {
  const { t } = useLanguage();

  return (
    <section id="products" className="section products">
      <div className="container">
        <div className="section-head section-head--center">
          <span className="kicker">{t.products.kicker}</span>
          <h2 className="section-title">{t.products.title}</h2>
          <p className="products__intro">{t.products.intro}</p>
        </div>
        <div className="products__grid">
          {PRODUCTS.map((product) => (
            <ProductCard product={product} key={product.code} />
          ))}
        </div>
      </div>
    </section>
  );
}
